// Fixed status colours from the TCAP Concept dashboard design; they signal
// done / next rather than brand, so they don't follow the partner colorScheme.
export const SETUP_GREEN = '#638C72';
export const SETUP_BLUE = '#3EAFEB';
